import styled from 'styled-components';
import { BasicSectionContainer } from 'screens/style';
import { colors } from 'constants/colors';
import { styleSizes } from "constants/styleSizes";

export const SignUpSectionContainer = styled(BasicSectionContainer)`
  width: 100%;
  min-height: 667px;
  display: flex;
  justify-content: center;
  align-content: center;
  
  .innerContainer {
    display: flex;
    justify-content: center;
    align-content: center;
  }
  

`;

export const SignUpFormContainer = styled.div`

  min-width: 340px;
  background-color: transparent;
  margin: 64px 0;
  z-index: 100;
  @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
    margin: 48px 0;
  }
  @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
    margin: 32px 0;
  }
  .warning {
    position: relative;
  }
  .formTitle {
    font-size: 48px;
    font-weight: bold;
    color: ${colors.black};
    margin-bottom: 32px;
    text-align: center;
  }

  .inputFieldContainer {
    width: 100%;
  }

  .buttonContainer {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 16px;
  }

  .tips {
    font-size: 16px;
    color: ${colors.hoverBlue};
    text-decoration: underline;
    margin-bottom: 16px;
    cursor: pointer;
  }

  .termsOfServiceContainer {
    width: 100%;
    margin-bottom: 16px;

    .required {
      margin-top: 8px;
      color: ${colors.red};
      font-size: 16px;
    }

    .termsOfService {
      display: flex;
      padding-left: 5px;

      .text {
        margin-left: 5px;

        .plainText {
          font-size: 16px;
          height: 30px;
          line-height: 24px;
          color: ${colors.black};
        }
      }
    }
  }

  .dividerContainer {
    width: 100%;
    display: flex;
    margin: 16px 0 16px 0;
    color: ${colors.almostBlack};

    span {
      margin: 0 10px;
    }

    .divider {
      width: 100%;
      padding: 0 15px;
      align-items: center;
      margin: auto;
      box-sizing: border-box;
      border: 0;
      border-top: 1px solid ${colors.signInBorderColor};
    }
  }

  .signInBox {
    text-align: center;
  }
  .socialLogin {
    max-width: 340px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 16px;
    .socialButton {
      border: 1px solid ${colors.noBookingText};
      width: 100%;
      height: 48px;
      display: flex;
      flex-direction: row;
      gap: 16px;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
`;
